<template>
  <Transition>
  <div class="container question-container mt-4">
    <div class="question d-flex jusftify-content-center align-items-center">
      <!-- <i class="bi bi-circle-fill"></i> -->
      <div class="d-flex-column  w-100 ">
        <!-- <div class="mr-3">Objective 1</div> -->
        <div class="row ml-1" style="position: relative;">
          <div class="iconOfEmployee" style="width: 50px; height: 50px; border: 2px;"></div>
          <div class="col-md-8 col-sm-12">
            <div class="d-flex-column">
              <label for="question-input" style="font-size: 1.2rem;"><strong>{{ questionText }}</strong></label>
              <label v-if="questionEmpId" for="question-input" style="font-size: 0.75rem; margin-left: 10px;"><b>(Assigned to: </b>{{ questionEmpId }} - {{ questionEmpName }})</label>

              <!-- <input v-if="userId !== 'ADM01'" id="question-input" type="text" name="question-input" class="" maxlength="50" placeholder="Enter your answer" style="width: 100%; padding: 5px;"> -->
              <!-- <div v-if="userId != 'ADM01' || !this.permissions.includes('Performance-Management-Permission')" style="font-size: 0.9rem; font-style: italic;">(expand for more details)</div> -->

              <div style="display: flex; overflow-x: auto; gap: 5px; margin-top: auto; width: 100%; ">
                <div
                  style="font-weight: 500; font-size: 0.8rem; white-space: nowrap; height: 100%; cursor: pointer;"
                  
                >
                  <div style="background-color: rgb(202, 191, 233); padding: 2px 5px; border-radius: 5px;">
                    {{ departments }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-row ml-auto">
            <!-- Progress Setter Flags -->
            <div v-if="formType == 'My Forms'" class="d-flex ml-auto">
              <div v-if="progress == 'In Progress' || progress == null" class="d-flex align-items-center">
                <button style="font-size: 0.6rem; background-color: rgba(255, 255, 14, 0.5); border: 2px solid rgba(255, 255, 14, 1); padding: 5px 10px; height: 40px; margin-right: 20px; margin-top: auto; margin-bottom: auto; border-radius: 10px; box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);" @click="toggleProgress(questionId)">
                  <b>In Progress</b>
                </button>
              </div>
              <div v-if="progress == 'Complete'" class="d-flex align-items-center">
                <button style="font-size: 0.6rem; background-color: rgba(14, 255, 34, 0.5); border: 2px solid rgba(14, 255, 34, 1); padding: 5px 10px; height: 40px; margin-right: 20px; margin-top: auto; margin-bottom: auto; border-radius: 10px; box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);" @click="toggleProgress(questionId)">
                  <b>Complete</b>
                </button>
              </div>
            </div>  
            
            <div v-if="formType == 'All Forms' || employeeId == 'SG001'" class="buttons-holder d-flex ml-auto" style="margin-right: 10px;">
              <div v-if="formType == 'All Forms'  && permissions.includes('Performance-Management-Permission') || (userId == 'SG001')" class="edit-button-holder" @click="editEntry(questionId)">
                  <img :src="editBtn" class="edit-button" alt="">
              </div>
              <div v-if="formType == 'All Forms'  && permissions.includes('Performance-Management-Permission') || (userId == 'SG001')" class="delete-button-holder" @click="deleteEntry(sectionId, questionId)">
                  <img :src="deleteBtn" class="delete-button" alt="">
              </div>
            </div> 

            <div class="dropdown" style="position: static; right: 0%; margin-right: 20px; margin-top: auto; margin-bottom: auto; box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3); height: fit-content; border-radius: 10px;">
              <button class="btn btn-secondary dropdown-toggle" :class="{ 'showDropDown': dropDownIsOpen == true}" type="button" style="height: 40px;" data-toggle="dropdown" aria-expanded="false" @click="showDropDown">
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    
    <Transition name="fade">
    <div v-if="dropDownIsOpen" class="dropdown-tab row">
      <div class="col-md-12">
        <hr style="border: 1px dashed rgb(253, 75, 75); width: 100%;">
      </div>
      <div class="col-md-12">
        <div class="d-flex-column">
          <div class="" style="margin: 10px 0px 20px 0px; font-size: 0.9rem; font-style: italic;">{{ description }}</div>
          <label style="font-size: 0.9rem;">
            <b>Employee Response: </b>
          </label>
          <textarea v-model="employeeResponse" rows="7" cols="40" placeholder="Enter your response" style="padding: 5px; width: 100%;" @input="sendDataToParent('Employee Response', questionId)" @blur="focusLost('Employee Response', questionId)" :disabled="formType == 'Team Forms' || submitted == true || formStatus == 'Inactive'"></textarea>
        </div>
      </div>
      <div class="col-md-12">
        <hr style="border: 1px dashed rgb(253, 75, 75); width: 100%;">
      </div>
      <div class="col-md-12">
        <div class="d-flex-column">
          <label style="font-size: 0.9rem;">
            <b>Reviewer Response: </b>
          </label>
          <textarea v-model="reviewerResponse" rows="7" cols="40" placeholder="Enter your response" style="padding: 5px; width: 100%;" @input="sendDataToParent('Reviewer Response', questionId)" @blur="focusLost('Reviewer Response', questionId)" :disabled="formType == 'My Forms' || reviewerSubmitted == true || formStatus == 'Inactive'"></textarea>
        </div>
        <!-- <div class="mt-2" style="margin-left: auto; width: min-content">
          <button class="btn btn-primary" @click="updateQuestion(userId, questionId)">Submit</button>
        </div> -->
      </div>
      <div v-if="(formType != 'My Forms' && this.storedAttachment && submitted) || formType == 'My Forms'" class="col-md-12">
        <hr style="border: 1px dashed rgb(253, 75, 75); width: 100%;">
      </div>

      <div>
        <div style="margin: 5px 20px;">
          <label v-if="(formType != 'My Forms' && this.storedAttachment && submitted) || formType == 'My Forms'" for="file_attachment " style="font-size: 0.9rem;">
           <b>File Attachment:</b><span title="Click for help" style="color:red;cursor:pointer;" class="mdi mdi-help-circle-outline pmfile" v-on:click="helpcomment" ></span>
          </label>
          <div v-if="formType == 'My Forms'" style="margin-bottom: 20px">
            <input type="file" id="file_attachment" name="file_attachment" @change="handleFileUpload">
          </div>
          <div v-if="this.storedAttachment && ((formType != 'My Forms' && submitted) || formType == 'My Forms')" style="margin: 5px 0px">
            <button id="attached_file" class="btn btn-info" @click="downloadAttachment(storedAttachment)">Download Attachment</button>
          </div>
        </div>
      </div>

      <!-- <div v-if="formType != 'My Forms' && (storedAttachment != '' || storedAttachment != null)" class="col-md-12">
        <hr style="border: 1px dashed rgb(253, 75, 75); width: 100%;">
      </div> -->

    </div>
    </Transition>

    <Transition>
    <div v-if="showEditQuestion" class="edit-question-container" style="">
      <form ref="form" class="d-flex flex-column" action="">
        <div>
          <hr style="border: 1px dashed rgb(253, 75, 75); width: 100%;">
        </div>
        <label for="question_text">
          <b>Enter title:</b>
        </label>
        <textarea v-model="questionInput" id="question_text" name="question_text" rows="4" cols="60"></textarea>
          <!-- My department selection code starts here -->
          <label for="description" style="margin-top: 10px;">
            <b>Enter description:</b>
          </label>
          <textarea v-model="descriptionInput" id="description" name="description" rows="4" cols="60"></textarea>
      </form>
      <div class="btn-holder" style="width: 100%">
        <!-- <button type="button" class="btn btn-primary" style="width: fit-content; margin: 20px 0px 0px 0px; margin-left: auto">Submit</button> -->
      </div>
    </div>
    </Transition>

  </div>
  </Transition>
</template>

<script>
import all from '../assets/all.png';
import australia from '../assets/australia.png';
import china from '../assets/china.png';
import hongkong from '../assets/hong-kong.png';
import india from '../assets/india.png';
import japan from '../assets/japan.png';
import malaysia from '../assets/malaysia.png';
import philippines from '../assets/philippines.png';
import singapore from '../assets/singapore.png';
import deleteBtn from '../assets/Delete_btn.png';
import editBtn from '../assets/edit-icon.png';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';
export default {
  props: ['mode', 'employeeId', 'formStatus', 'questionText', 'regions', 'departments', 'userId', 'sectionId', 'questionId', 'description', 'questionEmpId', 'questionEmpName', 'storedEmpResponse', 'storedRevResponse', 'storedProgress', 'storedAttachment', 'published', 'submitted', 'reviewerSubmitted', 'reviewStartDate', 'permissions'],
  mounted(){
    this.progress = this.storedProgress;
    // console.log('formType: ', this.formType);
    // console.log('formType: ', this.permissions);
    this.formType = this.$route.params.formType;
    if(this.formType != 'My Forms' && this.submitted) {
      this.employeeResponse = this.storedEmpResponse;
    } else if(this.formType == 'My Forms') {
      this.employeeResponse = this.storedEmpResponse;
    }
    if((this.formType == 'My Forms' || this.formType == 'All Forms') && this.reviewerSubmitted) {
      this.reviewerResponse = this.storedRevResponse;
    } else if(this.formType == 'Team Forms') {
      this.reviewerResponse = this.storedRevResponse;
    }
    this.questionInput = this.questionText;
    this.descriptionInput = this.description;
  },
  computed: {
    progressColor() {
      if(this.progress == 0) {
        return 'red';
      } else if(this.progress == 100) {
        return 'green';
      }
      return 'black';
    },
    // employeeName() {
    //   return this.employee ? this.employee.name : ''; // Access the employee's name
    // },
  },
  inject: ['receiveDataFromQuestion'],
  data() {
    return {
      allowedFileTypes: [
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', //.pptx
        'application/vnd.ms-powerpoint', //.ppt
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //.docx
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //.xlsx
        'application/msword', //.doc
        'application/pdf', //.pdf
        'application/zip', //.zip
        'application/x-zip-compressed',
        'application/vnd.rar', //.rar
        'image/gif',
        'image/png',
        'image/jpeg',
        'image/webp',
        'text/plain' //.txt
      ],
      all: all,
      australia: australia,
      china: china,
      hongkong: hongkong,
      india: india,
      japan: japan,
      malaysia: malaysia,
      philippines: philippines,
      singapore: singapore,
      message: 'Question Component',
      progress: 'In Progress',
      dropDownIsOpen: false,
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      employeeResponse: '',
      reviewerResponse: '',
      employeeName: '',
      attachment: '',
      questionInput: '',
      descriptionInput: '',
      showEditQuestion: false,
      formType: '',
    };
  },
  methods: {
    getDepartmentName(department) {
    switch (department) {
      case 'Executive Management': return 'Executive Management';
      case 'People, Performance & Culture': return 'People, Performance & Culture';
      case 'Technology & Innovation': return 'Technology & Innovation';
      case 'Research & Development': return 'Research & Development';
      case 'Business Operations': return 'Business Operations';
      case 'Customer Development': return 'Customer Development';
      case 'Marketing': return 'Marketing';
      case 'MD Office': return 'MD Office';
      case 'Projects': return 'Projects';
      case 'Finance': return 'Finance';
      case 'Legal': return 'Legal';
      case 'Sales': return 'Sales';
      }
    },
    showDropDown() {
      this.showEditQuestion = false;
      this.dropDownIsOpen = !this.dropDownIsOpen;
    },
    updateQuestion(userId, questionId) {
      if(userId == 'ADM01' || this.permissions.includes('Performance-Management-Permission')) {
        axios.patch(this.$hostName + '/updateQuestion', {
          'id': questionId,
          'reviewer_response': this.reviewerResponse
        })
        .then(() => {
        })
        .catch(error => console.error(error));
      }
    },
    sendDataToParent(type, id) {
      if(type == 'Employee Response') {
        let val = this.employeeResponse;
        this.receiveDataFromQuestion(val, type, id);
      } else if(type == 'Reviewer Response') {
        let val = this.reviewerResponse;
        this.receiveDataFromQuestion(val, type, id);
      }
    },
    toggleProgress(questionId) {
      if(this.progress == 'In Progress' || this.progress == null) {
        this.progress = 'Complete';
      } else if(this.progress == 'Complete') {
        this.progress = 'In Progress';
      }
      let eventData = {
        progress: this.progress, 
        questionId: questionId,
      };
      this.$emit('progress-change', eventData);
    },
    deleteEntry(sectionId, questionId) {
      // this.loading = true;
      Swal.fire({
        title: 'Are you sure you want to delete this entry?',
        showCancelButton: true,
        customClass: {
          confirmButton: 'mr-2',
          cancelButton: 'ml-2',
        }
      })
      .then(response => {
        if(response.isConfirmed) {
          this.loading = true;
          axios.delete(this.$hostName + '/deleteQuestion', {data: {'section_id': sectionId, 'id': questionId} })
          .then(() => {
            this.$emit('getAllSections');
          })
          .catch(error => console.error(error))
          .finally(() => this.loading = false);
        }
      });
    },
    focusLost(type, id) {
      if(type == 'Employee Response') {
        this.$emit('EmployeeEOR', id);
        // this.receiveDataFromQuestion(val, type, id);
      } else if(type == 'Reviewer Response') {
        this.$emit('ReviewerEOR', id);
        // this.receiveDataFromQuestion(val, type, id);
      }
    },
    handleFileUpload(event) {
      // console.log('event:', event);
      event.preventDefault();
      let maxSize = 16 * 1024 * 1024;
      if(event.target.files[0].size > maxSize) {
        event.target.value = '';
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: 'File size limit of 16 mb exceeded, please choose a different file.'
        });

        this.attachment = '';
      } else if(!this.allowedFileTypes.includes(event.target.files[0].type)) {
        // console.log('type:', event.target.files[0].type);
        event.target.value = '';
        Swal.fire({
          title: 'Invalid file type!',
          icon: 'error',
          text: 'Selected file type is not allowed. Please choose from .ppt, .pptx, .doc, .docx, .pdf, .png, .jpg/jpeg, .webp, .zip, .rar, zipped folder'
        });
      } else {
        this.attachment = event.target.files[0] ? event.target.files[0] : '';
      }
      // console.log('attac:', this.attachment);
    },
    uploadFile(questionId) {
      let formData = new FormData();
      if(this.attachment !== '') {
        formData.append('attachment', this.attachment);
        formData.append('id', questionId);
        // console.log('calling:', formData);
        axios({
          method: 'post',
          url: this.$hostName + '/uploadQuestionFile',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {})
        .catch(error => console.error(error));
      }
    },

    updateChanges(questionId, reviewStartDate = null, reviewEndDate = null, reviewerDueDate = null) {
      this.$emit('loading');
      return new Promise((resolve, reject) => {
        axios.patch(this.$hostName + '/updateQuestion', { id: questionId, question_text: this.questionInput, description_text: this.descriptionInput, appraisal_start_date: reviewStartDate, appraisal_end_date: reviewEndDate, reviewer_due_date: reviewerDueDate })
        .then((response) => {
          this.showEditQuestion = false;
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
      });
    },

    editEntry() {
      this.dropDownIsOpen = false;
      this.showEditQuestion = !this.showEditQuestion;
      if(this.showEditQuestion) {
        this.$emit('editing');
      }
    },

    downloadAttachment(blobData) {
      // let blob = new Blob([blobData], {
      //   type: 'application/octet-stream',
      // });

      // let url = window.URL.createObjectURL(blob);

      // let link = document.createElement('a');
      // link.href = url;
      // link.download = 'attachment.extension';

      // link.click();

      // window.URL.revokeObjectURL(url);
      let type = blobData.split('/')[1];
      let fileTyepe = type.split(';')[0];
      var a = document.createElement('a');
      a.href = blobData;
      a.download = 'attachment.' + fileTyepe; 
      a.click();
    },
    helpcomment(){
        Swal.fire({
            html: `<p><span style="margin-right:10px;" >File attachement can include, appreciation email and supporting documents</span></p><p><strong><span style="color: red">*</span> Zip and upload in case multiple files </strong></p>`,
          });
      },
  },

};
</script>

<style scoped>

* {
  font-family: Montserrat;
  box-sizing: border-box;
}
.question-container {
  box-shadow: 2px 2px 8px rgb(87, 87, 87);
  border-radius: 10px;
  padding: 15px;
}

.iconOfEmployee {
  border: 3px black;
  border-radius: 150px;
  /* height: 20px;
  width: 20px; */
  background-color: #d05959;
}

.progress-slider {
  width: 200px;
  background-color: #d05959;
}

.dropdown-toggle {
  background-color: unset !important;
  color: unset !important;
  border: unset !important;
  font-size: 1.2rem;
  margin: auto;
  transition: transform 0.3s ease-in-out;
}

.showDropDown {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}

.dropdown-tab {
  /* animation: slide-up 3s ease-in-out; */
}

@keyframes slide-up {
  0% {
    height: 0%;
  }

  100% {
    height: 100%;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.delete-button, .edit-button {
    height: 30px;
    width: 30px;
}

.edit-button-holder, .delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto 0 auto 10px;
}

.edit-button-holder:active, .delete-button-holder:active {
    transform: scale(0.9);
    transition: transform 0.3s ease-in-out;
}

.edit-button-holder:hover, .delete-button-holder:hover {
    cursor: pointer;
}

.pmfile {
  margin-left: 10px;
  font-size: 22px;
}
</style>
